export default __webpack_public_path__ + "static/2019-largest-music-festivals-5b408c2c04a9bccc981fda88859e7a7d.jpg";